var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { editable, editObservable } from '../../../utils/mobx/decorators/editable';
import { decimal } from '../../../utils/serializr/schema/inner/decimal';
import { withDefault } from '../../../utils/serializr/schema/middle/withDefault';
import { primitive } from '../../../utils/serializr/serializr';
export class QuestionScoringStore {
    parent;
    minGrade = 1.0;
    maxGrade = 6.0;
    minDayOfYear = 0;
    maxDayOfYear = 365;
    constructor({ parent }) {
        editObservable(this);
        this.parent = parent;
    }
    get question() {
        return this.parent;
    }
    static get serializeInfo() {
        return {
            props: {
                minGrade: withDefault(decimal(1), '1.0'),
                maxGrade: withDefault(decimal(1), '6.0'),
                minDayOfYear: withDefault(primitive, 1),
                maxDayOfYear: withDefault(primitive, 365),
            },
        };
    }
}
__decorate([
    editable()
], QuestionScoringStore.prototype, "minGrade", void 0);
__decorate([
    editable()
], QuestionScoringStore.prototype, "maxGrade", void 0);
__decorate([
    editable()
], QuestionScoringStore.prototype, "minDayOfYear", void 0);
__decorate([
    editable()
], QuestionScoringStore.prototype, "maxDayOfYear", void 0);
__decorate([
    memoize
], QuestionScoringStore, "serializeInfo", null);
